import { window } from './facade/browser';
export function isBs3() {
    return window.__theme === 'bs4';
}
//# sourceMappingURL=ng2-bootstrap-config.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/utils/ng2-bootstrap-config.js
// module id = ../../../../angular-bootstrap-md/utils/ng2-bootstrap-config.js
// module chunks = 3